import { hasAppliedCrmFields } from "app/pages/sales-intelligence/domain/crm-integration/utils/custom-filters-dto-adapters";
import { useCrmCustomFiltersListViewModel } from "app/pages/sales-intelligence/modules/crm-integration/hooks/useCrmCustomFiltersListViewModel";
import type { LeadsSearchAllFiltersTypes } from "app/pages/sales-intelligence/modules/leads-search-filters/types/leadsSearchFilters.dto";
import { inclusionOptionMap } from "app/pages/sales-intelligence/types/commonMaps";

export const useResolveCrmAppliedState = (panelValue: Partial<LeadsSearchAllFiltersTypes>) => {
    const { integrationObject } = useCrmCustomFiltersListViewModel();
    const provider = integrationObject?.integrationName;

    if (!provider) {
        return null;
    }

    if (!hasAppliedCrmFields(panelValue, provider)) {
        return null;
    }

    return { provider, inclusionValue: inclusionOptionMap.includeOnly };
};
